// extracted by mini-css-extract-plugin
module.exports = {"iconLoader":"y3oo4","inner":"zo+pI","load4":"yVIOE","inner_size_small":"oq1lW"};